import React, { PropTypes } from 'react'
import { Control } from 'react-redux-form/immutable'
import acc from 'accounting'

const ListOfferingItem  = ({ item, k }) => {
  let disabled = false
  let label = 'success'
  let cl = ''

  if (item.get('is_recommended')) {
    cl = 'success'
  }
  if (item.get('is_repeat')) {
    cl = 'warning'
  }
  if (item.get('is_disabled')) {
    cl = 'disabled'
    label= 'danger'
    disabled = true
  }

  // compute slots
  const p = item.get('enrolled') / item.get('max_slots')
  if (p > 0.75) {
    label = 'warning'
  }
  if (p === 1) {
    label = 'disabled'
    disabled = true
  }

  return (
    <tr className={cl}>
      <td>
        <Control.checkbox
          model={`offeringState[${k}].is_checked`}
          disabled={disabled}
        />
      </td>
      <td><code>{item.get('subject_code')}</code></td>
      <td><small>{item.get('section')}</small></td>
      <td>{item.get('subject_name')}</td>
      <td><small>{item.get('schedule')}</small></td>
      <td className="text-right">{acc.formatNumber(item.get('units'), 1)}</td>
      <td><small>{item.get('instructor_name')}</small></td>
      <td><span className={`label label-${label}`}>{item.get('enrolled')}/{item.get('max_slots')}</span></td>
    </tr>
  )
}

ListOfferingItem.propTypes = {
  item: PropTypes.object,
  k: PropTypes.number,
}

export default ListOfferingItem



// WEBPACK FOOTER //
// ./src/containers/Enrolment/Modify/list-offering-item.js